var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F4F7F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_8)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1999 8H26.8986L35.966 17.4513V35.8341C35.966 38.1369 34.103 40 31.8081 40H16.1999C13.8971 40 12.034 38.1369 12.034 35.8341V12.1659C12.034 9.86306 13.897 8 16.1999 8V8Z",
    fill: "#E5252A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8906 8V17.3793H35.966L26.8906 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6637 31.8761V26.031H19.1504C19.7661 26.031 20.2539 26.1989 20.6217 26.5427C20.9895 26.8786 21.1734 27.3343 21.1734 27.9021C21.1734 28.4698 20.9895 28.9255 20.6217 29.2614C20.2539 29.6052 19.7661 29.7731 19.1504 29.7731H18.1589V31.8761H16.6637ZM18.1589 28.5018H18.9825C19.2064 28.5018 19.3823 28.4538 19.5023 28.3419C19.6222 28.2379 19.6862 28.094 19.6862 27.9021C19.6862 27.7102 19.6222 27.5663 19.5023 27.4623C19.3824 27.3504 19.2064 27.3024 18.9825 27.3024H18.1589V28.5018ZM21.7891 31.8761V26.031H23.8601C24.2679 26.031 24.6517 26.0869 25.0115 26.2069C25.3713 26.3268 25.6992 26.4948 25.987 26.7267C26.2749 26.9505 26.5067 27.2544 26.6747 27.6382C26.8346 28.022 26.9225 28.4618 26.9225 28.9575C26.9225 29.4453 26.8346 29.8851 26.6747 30.2689C26.5067 30.6527 26.2749 30.9565 25.987 31.1804C25.6991 31.4123 25.3713 31.5802 25.0115 31.7001C24.6517 31.8201 24.2679 31.8761 23.8601 31.8761H21.7891ZM23.2524 30.6047H23.6841C23.916 30.6047 24.1319 30.5807 24.3318 30.5248C24.5237 30.4688 24.7076 30.3808 24.8836 30.2609C25.0515 30.141 25.1874 29.973 25.2834 29.7491C25.3793 29.5253 25.4273 29.2614 25.4273 28.9575C25.4273 28.6457 25.3793 28.3818 25.2834 28.1579C25.1874 27.9341 25.0515 27.7662 24.8836 27.6462C24.7076 27.5263 24.5238 27.4383 24.3318 27.3823C24.1319 27.3264 23.916 27.3024 23.6841 27.3024H23.2524V30.6047ZM27.6742 31.8761V26.031H31.8321V27.3024H29.1694V28.2379H31.2963V29.5013H29.1694V31.8761H27.6742Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.fd2a3901.svg";
export { ForwardRef as ReactComponent };